// search-synonyms.json 작성 규칙 

// 1. 공통 키워드가 있는 상품의 경우

// 예를 들어 다음과 같이 상품명이 앞부분까지 동일한 상품이 여러 개 존재할 경우:
// butterflow pocket wide leg pant tall
// butterflow pocket wide leg pant regular
// 공통 키워드인
// butterflow pocket wide leg pant가 별도로 등록되어 있지 않으면,
// 검색 시 하위 상품 중 하나(tall)만 검색 결과로 노출되는 이슈가 발생.

// 2. 해결 방식 – 공통 키워드 엔트리 추가

// 공통 키워드 : butterflow pocket wide leg pant
// 해당 키워드를 대표 엔트리로 추가
// prefix는 기존 브랜드 인식 기준인 11을 유지

// prefix는 검색어가 너무 짧을 때는 치환하지 않기 위해서 (da만 써도 daily tote bag으로 자동으로 바뀌기때문에 한 제품만 검색됨)
// ex) slim fit cropped 가 있을 때 slimf(5자) 기준으로 prefix 설정

// PS.공통 키워드 easysoft가 있고, easy soft oversized fit cropped 혹은 easy soft wide도 등록하고싶을땐, 
// easysoft는 'easy s'으로 6자리 등록하고
// easy soft oversized fit cropped 는 easy soft o부터 쭈주죽 검색되어야하기 때문에 
// 'easysofto' 9로 등록하고 (앞에는 이미 등록됐기 떄문에 붙여서 세야함)
// easy soft wide 도 w 부터 검색되어야하기때문에 동이하게 9로 설정

// 3. 하위 상품 prefix 조정

// 하위 상품(tall / regular)은 대표 키워드를 충분히 입력했을 때만 분기되도록 prefix.min 값을 조정
// butterflowpocketwidelegpant(총 27자) 기준으로 + 1 한 28 로 그 분기된 요소에 입력
// butterflow pocket wide leg pant tall 의 prefix = 28
// butterflow pocket wide leg pant regualr 의 prefix = 28


// 즉, 해야할 사항
// 1. 공통 키워드 등록해야할 상품 확인
// 2. 공통 키워드 등록 - butterflow pocket wide leg pant 등록,  prefix 11은 유지 
// 3. 기존 키워드들 prefix 변경 - butterflow pocket wide leg pant tall ,,, prefix 11에서 28로 변경

// json 코드 마지막에 콤마 주의 ㅠㅠ

const loadSynonyms = async () => {
  try {
    const res = await fetch(window.SEARCH_SYNONYMS_URL + '?v=' + Date.now());

    if (!res.ok) throw new Error('Failed to load synonyms json');

    return await res.json();
  } catch (e) {
    console.warn('[synonyms] load failed', e);
    return { products: [] };
  }
};


(async () => {
    const normalize = (v) =>
    (v || '')
    .toLowerCase()
    .trim()
    .replace(/[\s\-_]+/g, '')
    .replace(/[\u00A0\u200B-\u200D\uFEFF]/g, '') // NBSP/zero-width 제거
    .replace(/[™®©]/g, '');

    

  const buildAliasMap = (data) => {
    const map = Object.create(null);
    const products = Array.isArray(data?.products) ? data.products : [];

    const add = (k, query) => {
        const key = normalize(k);
        if (!key) return;
        map[key] = query;
    };

    const addPrefixes = (base, query, minLen) => {
        const b = normalize(base);
        if (!b) return;
        // console.log('[prefix]', b, 'min=', minLen);

        const start = Math.max(1, Number(minLen) || 0);
        for (let i = start; i <= b.length; i += 1) {
        add(b.slice(0, i), query);
        }
    };

    products.forEach((p) => {
        const query = (p && p.query) || '';
        if (!query) return;

        const aliases = Array.isArray(p.aliases) ? p.aliases : [];
        const minLen = p?.prefix?.min ?? 6;

        // query 자체도 키 등록(혹시 사용자가 띄어쓰기 포함 입력해도 대응)
        add(query, query);

        // aliases는 "대표 키"만 넣어도 prefix 자동 생성
        aliases.forEach((a) => {
        if (!a) return;

        // 1) 정확 일치도 등록
        add(a, query);

        // 2) prefix 자동 등록
        addPrefixes(a, query, minLen);
        });
    });

    return map;
  };

  
  const DATA = await loadSynonyms();  
  const ALIAS_MAP = DATA ? buildAliasMap(DATA) : Object.create(null);

  const rewriteQ = (q) => {
    const key = normalize(q);
    // console.log('[input raw]', q, [...q].map(c => c.charCodeAt(0)));
    return ALIAS_MAP[key] || q;
  };

  const origFetch = window.fetch;

  window.fetch = function (input, init) {
    try {
      const urlStr = typeof input === 'string' ? input : input?.url;
      if (typeof urlStr === 'string' && urlStr.includes('/search/suggest')) {
        const u = new URL(urlStr, window.location.origin);
        const q = u.searchParams.get('q');

        if (q) {
          const rewritten = rewriteQ(q);
          if (rewritten !== q) {
            u.searchParams.set('q', rewritten);

            if (typeof input === 'string') {
              input = u.toString();
            } else if (input instanceof Request) {
              input = new Request(u.toString(), input);
            } else {
              input = u.toString();
            }
          }
        }
      }
    } catch (e) {}

    return origFetch.call(this, input, init);
  };
})();